// extracted by mini-css-extract-plugin
export default {"menu":"_0aYKV0G1--styles_menu__Tm-Uq","wiggle":"_0aYKV0G1--styles_wiggle__rVFbm","shimmer":"_0aYKV0G1--styles_shimmer__lNWpg"};